<template>
    <div>
        <span v-if="spiel" @click="filter(status.text.replace(' (verspätet)', ''))"
              :class="[status.class, 'font-weight-bold cursorStyle']">
            <span v-if="longText && status.completed">Ergebnis </span>
            <v-hover v-slot="{ hover }">
                <span :class="[{ 'hoverLetter': hover && allowHover }]">
                {{status.text.replace(' (verspätet)', '').replace('(kommentiert)', '')}}
                <span v-if="(spiel.infos.kommentar || spiel.infos.kommentarStrafe) && !longText"
                      class="black--text font-weight-regular">(kommentiert)</span>
                </span>
            </v-hover>
        </span>
        <div v-if="status.delayed && !longText" @click="filter('verspätet')"
             style="white-space: nowrap">
            <v-hover v-slot="{ hover }">
                <span v-if="status.delayed.delayedHeim"
                      :class="[{ 'hoverStatus': hover && allowHover },
                 'delayedText font-weight-bold cursorStyle']">
                    verspätet Heim: {{status.delayed.deltaHeim}}
                </span>
            </v-hover>
            <br v-if="status.delayed.delayedHeim && status.delayed.delayedGast">
            <v-hover v-slot="{ hover }">
                <span v-if="status.delayed.delayedGast"
                      :class="[{ 'hoverStatus': hover && allowHover },
                 'delayedText font-weight-bold cursorStyle']">
                    verspätet Gast: {{status.delayed.deltaGast}}
                </span>
            </v-hover>
        </div>
        <v-progress-linear v-if="status.text==='Spiel läuft' && !this.longText"
                           rounded indeterminate color="blue"></v-progress-linear>
    </div>
</template>

<script>
    import SpielService from "../../../services/data/spielService";
    export default {
        name: "spiel-status-text",
        props: ['spiel', 'saison', 'longText', 'allowHover'],
        computed: {
            status(){ return SpielService.getSpielStatusText(this.spiel);}
        },
        data: () => ({
            filtered: ''
        }),
        methods: {
            filter(value){
                this.$emit('filtered', value);
            },
        },
    }
</script>

<style scoped>
    .cursorStyle{cursor: pointer}
    .delayedText{font-size: 12px; color: #aaa}
    .hoverStatus{color: #666}
    .hoverLetter{letter-spacing: 0.4px}
</style>